import { FC, ReactNode } from 'react';
import { LazyIcon } from '@getstream/ui-library/build';

import Title from '../Title';

import { Content } from '../../../types/tour';

import styles from './ContentGenerator.module.css';

export type Props = {
  children?: ReactNode | undefined;
  content?: Content;
  code?: any;
  icon?: boolean;
  demoLink?: string;
  demoText?: string;
};

export const ContentGenerator: FC<Props> = ({
  content,
  code,
  children,
  demoLink,
  demoText,
}) => {
  return (
    <div>
      <div className="flex items-start gap-4">
        {content?.icon && <LazyIcon name={content.icon} size="58" />}
        <Title>{content?.title}</Title>
      </div>

      {content?.paragraphs?.map((p, key) => (
        <p
          key={key}
          className={styles.getStartedParagraph}
          dangerouslySetInnerHTML={{ __html: p }}
        />
      ))}
      {demoLink && (
        <a
          href={demoLink}
          target="_blank"
          className="uppercase font-bold text-stream hover:text-stream-darker mb-8 flex items-center gap-2 hover:underline"
        >
          {demoText}
          <LazyIcon name="external" size="14" />
        </a>
      )}
      {code}
      <div className="my-6 text-nav">
        {content?.blockquotes?.map((blockquote, key) => (
          <blockquote
            key={key}
            className={styles.getStartedBlockquote}
            dangerouslySetInnerHTML={{ __html: blockquote }}
          />
        ))}
      </div>
      {children}
    </div>
  );
};
